export function isInViewport(elem) {
  var distance = elem.getBoundingClientRect();
  return distance.top < (window.innerHeight || document.documentElement.clientHeight) && distance.bottom > 0;
}
